import { LAST_3_MONTHS_FILTER } from "features/purchaseHistory/purchaseHistoryPeriod";
import { usePurchaseHistoryApiFlag } from "features/purchaseHistory/usePurchaseHistoryApiFlag";
import { useState } from "react";

import { useSettlementHistoryFromApi } from "./hooks/useSettlementHistoryFromApi";
import { useSettlementHistoryFromFirestore } from "./hooks/useSettlementHistoryFromFirestore";

import type { ChangeEventHandler } from "react";

export const useThis = () => {
  const isApiEnabled = usePurchaseHistoryApiFlag();

  const [isShowingAll, setIsShowingAll] = useState(false);
  const [selectedFilter, setSelectedFilter] =
    useState<string>(LAST_3_MONTHS_FILTER);
  // 期間の基準時刻はフィルタ選択時に確定させる。レンダリングごとに変わるとページ間で期間がずれる
  const [periodBaseDate, setPeriodBaseDate] = useState(() => new Date());

  // 両方のhookは常に呼び、フラグで有効な側だけが取得する
  const fromFirestore = useSettlementHistoryFromFirestore({
    enabled: !isApiEnabled,
    isShowingAll,
    selectedFilter,
  });
  const fromApi = useSettlementHistoryFromApi({
    enabled: isApiEnabled,
    periodBaseDate,
    selectedFilter,
  });

  const source = isApiEnabled ? fromApi : fromFirestore;

  const handleLoadMore = () => {
    if (isApiEnabled) {
      fromApi.loadMore();
      return;
    }
    setIsShowingAll(true);
  };

  const handleSelectFilter: ChangeEventHandler<HTMLSelectElement> = (event) => {
    setSelectedFilter(event.currentTarget.value);
    setIsShowingAll(false);
    setPeriodBaseDate(new Date());
  };

  return {
    allHistoryCards: source.allHistoryCards,
    fetchStatus: source.fetchStatus,
    handleLoadMore,
    handleSelectFilter,
    selectedFilter,
    settlementYearList: source.settlementYearList,
    showLoadMore: source.showLoadMore,
  };
};
